import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import { getI18n, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import routes from "../../../routes/routes";
import LoaderOverlay from "../../layout/components/LoaderOverlay";
import {
  finishRentalViaTokenBegan,
  finishRentalViaTokenCompleted,
  finishRentalViaTokenCompletionFailed,
} from "../../../redux/slice/bookingCreation/bookingCreationSlice";
import { useNavigate, useParams } from "react-router-dom";
import { baseStore, RootState } from "../../../redux/store";
import CustomButton from "../../layout/components/CustomButton";
import TenantLogo from "../../layout/components/TenantLogo";
import { useFinishRentalViaToken } from "../../../redux/flows/finishRentalViaTokenFlow";
import { Rental } from "../../../types/rental";

const RootWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  paddingTop: theme.spacing(2),
  boxSizing: "border-box",
  backgroundColor: "var(--dark-background-color)",
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 1000,
  margin: "0 auto",
  textAlign: "center",
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
}));

const TenantLogoWrapper = styled(Box)(({ theme }) => ({
  width: "100px",
  [theme.breakpoints.up("lg")]: {
    width: "150px",
  },
  margin: "0 auto",
}));

const StyledHeaderTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

const StyledInfoTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
}));

const FinishRentalViaToken = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const finishRentalViaToken = useFinishRentalViaToken();

  const { t } = useTranslation();
  const pathParams = useParams();
  const token = pathParams.token;
  const finishRentalCompletionLoading = useSelector(
    (state: RootState) => state.bookingCreation.loading.finishRental
  );
  const [finshRentalCompletionFailed, setFinishRentalCompletionFailed] =
    useState<boolean>(false);

  useEffect(() => {
    const manageFinishRentalViaToken = async () => {
      finishRentalViaTokenBegan();
      if (typeof token !== "string") {
        finishRentalViaTokenCompletionFailed();
        return;
      }

      const rental = (await finishRentalViaToken(token)) as Rental;
      if (!rental) {
        // navigate to finish rental failed
        setFinishRentalCompletionFailed(true);
        return;
      }

      navigate(routes.orders);

      return;
    };

    manageFinishRentalViaToken();
  }, []);

  const navigateToBookings = () => {
    navigate(routes.orders);
    dispatch(finishRentalViaTokenCompleted());
  };
  return (
    <RootWrapper>
      <ContentWrapper>
        <TenantLogoWrapper>
          <TenantLogo style={{ width: "100%", height: "100%" }} />
        </TenantLogoWrapper>
        {finshRentalCompletionFailed && (
          <>
            <StyledHeaderTypography variant={"h1"}>
              {t("rental.return.error_header")}
            </StyledHeaderTypography>
            <StyledInfoTypography variant={"body1"}>
              {t("rental.return.error_info")}
            </StyledInfoTypography>

            <CustomButton
              style={{ width: "50%", height: "100%", marginTop: "32px" }}
              isButtonDark={true}
              fullWidth={false}
              onClick={navigateToBookings}
              fontSize={"18px"}
              children={t("rental.return.go_to_bookings")}
            />
          </>
        )}
      </ContentWrapper>
      <LoaderOverlay open={finishRentalCompletionLoading} />
    </RootWrapper>
  );
};

export default FinishRentalViaToken;
